import palette from '@lib/core/src/theme/palette';
import { Button, Select, Stack, styled, TextareaAutosize, Typography } from '@mui/material';

export const GoalsContainer = styled(Stack)(() => ({
  gap: 16,
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const ContentRow = styled(Stack)(() => ({
  gap: 16,
  flexDirection: 'row',
  height: '100%'
}));
